// @ts-nocheck
//@flow

import React, { Fragment } from 'react';

import './root.scss';

import Header from '../header/header.tsx';
import Wallet from '../wallet/wallet.tsx';
import Desktop from '../desktop/desktop.tsx';
import { updateTitle } from '../helpers/other/strings';
import RootProvider from './root.provider.tsx';
import { isMobile } from '../helpers/device';
import { globalTracer } from 'opentracing';
import { initTracer } from '../tracing/setup';

const Root = () => {
  updateTitle();
  initTracer();
  const tracer = globalTracer();
  const span = tracer.startSpan("Load UI")

  const isMobileDevice: boolean = isMobile.any();

  return (
    <RootProvider>
      {!isMobileDevice && <Desktop span={span} />}

      {isMobileDevice && (
        <Fragment>
          <Header />
          <Wallet span={span} />
        </Fragment>
      )}
    </RootProvider>
  );
};

export default Root;
